import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetCustomerRetentionReport } from "../services/reports.services";

const CustomerRetentionReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/customerretentionreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/customerretentionreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const CustomerName = params?.CustomerName;
  const QueryType = params?.QueryType;

  const loading = useAppSelector((state) => state.reports.loading);
  const CustomerRetentionListForReport = useAppSelector(
    (state) => state.reports.CustomerRetentionListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        CustomerName: CustomerName !== "0" ? CustomerName : "",
        QueryType: QueryType !== "0" ? QueryType : "",
      };
      dispatch(GetCustomerRetentionReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "CustomerRetentionReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "customerretentionreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Customer Retention Report{" "}
          <span style={{ fontSize: 15 }}>
            {CustomerRetentionListForReport &&
              CustomerRetentionListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            CustomerRetentionListForReport &&
            CustomerRetentionListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            CustomerRetentionListForReport &&
            CustomerRetentionListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {CustomerRetentionListForReport &&
      CustomerRetentionListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Customer Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Email ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Mobile No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Bookings
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Total Revenue
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  First Booking Date
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Last Booking Date
                </th>
              </tr>
            </thead>
            <tbody>
              {CustomerRetentionListForReport &&
                CustomerRetentionListForReport.length > 0 &&
                CustomerRetentionListForReport?.map(
                  (CustomerRetention: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {CustomerRetention?.Customername || ""}
                      </td>
                      <td className="text-center">
                        {CustomerRetention?.EmailId || ""}
                      </td>
                      <td className="text-center">
                        {CustomerRetention?.MobileNo || ""}
                      </td>
                      <td className="text-center">
                        {CustomerRetention?.TotalBookings || ""}
                      </td>
                      <td className="text-end">
                        {CustomerRetention?.TotalRevenue
                          ? formatIndianNumber(
                              CustomerRetention?.TotalRevenue || ""
                            )
                          : ""}
                      </td>
                      <td className="text-center">
                        {CustomerRetention?.FirstBookingDate
                          ? moment(
                              CustomerRetention?.FirstBookingDate,
                              "DD-MM-YYYY"
                            ).format("DD MMM YYYY")
                          : ""}
                      </td>
                      <td className="text-center">
                        {CustomerRetention?.LastBookingDate
                          ? moment(
                              CustomerRetention?.LastBookingDate,
                              "DD-MM-YYYY"
                            ).format("DD MMM YYYY")
                          : ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default CustomerRetentionReportView;
